import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

const groupsOfOrganization = async (organizationId) => {
    const URL = SERVER_PATH + apiEndpoints.groupsOfOrganization
    return resolveRequest(axios.post(URL, { organizationId }, { withCredentials: true }))
}

export default groupsOfOrganization